import { useContext } from "react";
import { TipContext } from "../../containers/TipContext";
import Tippy from "@tippyjs/react";
import styles from "./Tip.module.css";

const Tip = ({ children, name }) => {
  const tips = useContext(TipContext);
  return (
    <>
      <Tippy
        content={
          <div
            className={styles.tip}
            dangerouslySetInnerHTML={{
              __html:
                tips.tips && tips.tips[name] ? tips.tips[name] : "Loading...",
            }}
          />
        }
        onShow={() => {
          if (!tips.showTips) tips.setShowTips(true);
        }}
      >
        <div className={styles.txt}>{children}</div>
      </Tippy>
    </>
  );
};

export default Tip;
